import { Component, Input, OnInit } from '@angular/core';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { KbnStatus } from '@core/constants';
import { BatsuMaruConfigModel } from '@core/models/models';
import { LocalStorageService } from '@core/services/common';

@Component({
  selector: 'caremoni-batsu-maru',
  templateUrl: './batsu-maru.component.html',
  styleUrl: './batsu-maru.component.scss'
})
export class BatsuMaruComponent implements OnInit {
  @Input() data: any;
  @Input() config: BatsuMaruConfigModel = new BatsuMaruConfigModel();
  labelConfig: BatsuMaruConfigModel = new BatsuMaruConfigModel();
  displayText: string = '';
  moisture : string = '';
  isShow: boolean = false;
  isShowColMoiture: boolean = false;

  constructor(private LocalStorageService: LocalStorageService) { }

  ngOnInit(): void {
    let GetisShowColMoiture = this.LocalStorageService.getSettingDialog(LOCAL_STORAGE_KEY.settingDialog);
    if (GetisShowColMoiture && GetisShowColMoiture.headers) {
      let snackHeader = GetisShowColMoiture.headers.find(
        (h: any) => h.field === 'snack'
      );
      this.isShowColMoiture = snackHeader?.hasSubHeader;
    }
    this.isShow = this.data?.status_kbn > 0;
    if(this.config) {
      if (this.data?.status_kbn == KbnStatus.STATUS_CARRY_OUT) {
        this.displayText = '〇';
      } 
      if (this.data?.attention_flg) {
        this.labelConfig.highlight = true;
      }
    }
    this.moisture = this.data?.moisture ?? '';
  }
}